import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import type { FunctionComponent } from "react";
import { CircleAlert } from "lucide-react";

export const NotFoundPage: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-between flex-col size-full w-screen h-screen">
      <div className="flex justify-center border-b-[1px] border border-solid p-4 bg-primary md:bg-white">
        <h4 className="m-0 text-xl font-bold md:text-primary text-white">
          ROSC
        </h4>
      </div>

      <div className="flex flex-col justify-center items-center size-full">
        <div className="text-center md:w-[50%] lg:w-[40%] w-[80%]">
          <div className="flex justify-center mb-4">
            <CircleAlert />
          </div>

          <h6 className="font-bold">{t("notFound.title")}</h6>

          <p className="mt-2">{t("notFound.description")}</p>

          <Link to={"/"}>
            <Button
              className="mt-6"
              data-testid="signUp-submit-button"
              size="lg"
              type="submit"
            >
              {t("notFound.btnTitle")}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
